<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="模板名称" :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }">
              <a-input placeholder="请输入模板名称" v-model="queryParam.name"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="模板编码" :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }">
              <a-input placeholder="请输入模板编码" v-model="queryParam.code"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="6" style="text-align: left">
            <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
            <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
             <a-button  @click="handleEditCode" type="primary" icon="plus" style="margin-left: 8px" >新增</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <a-table :columns="columns" size="small" :scroll="{ y: '200px' }" :dataSource="dataSource" :pagination="ipagination"
      :loading="loading" @change="handleTableChange">
      >
      <span slot="action" slot-scope="text,record,index">
        <a  @click="handleEditCode(record)">编辑</a>
      </span>
    </a-table>

   <a-modal title="编辑模板" width="60%" :visible="formVisible" :confirmLoading="confirmLoading" @ok="handleSubmit" @cancel="handleCancel" :bodyStyle="{ height: '700px', overflow: 'auto' }">
  <!-- 研究中心 Form Item with left alignment -->
  <a-form-model-item label="研究中心" style="margin-left: 0;">
    <a-select placeholder="请选择研究中心" v-model="formData.centerId" style="width: 50%;">
      <a-select-option v-for="(item, index) in centerList" :key="index" :value="item.center.id">
        {{ item.center.name }}
      </a-select-option>
    </a-select>
  </a-form-model-item>

  <!-- 模板内容 Form Item with left alignment -->
  <a-form-model-item label="模板内容" help="请注意：输入框右下角图标可以调整输入框大小。" class="j-field-content" style="text-align: left;">
    <div class="editor-container" style="text-align: left;">
      <j-editor v-model="formData.msgContent" class="custom-editor"></j-editor>
    </div>
  </a-form-model-item>
</a-modal>



  </a-card>
</template>

<script>
import JEditor from '@comp/jeecg/JEditor'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { CACHE_PROJECT_ID } from '@/constants/project'
import { getAction, postAction, putAction } from '@/api/manage'
import Vue from 'vue'

export default {
  name: 'Template',
  components: { JEditor },
  mixins: [JeecgListMixin],
  data() {
    return {
      columns: [
        {
          title: '所属中心',
          align: 'center',
          dataIndex: 'centerName',
          width: 100,
        },
        {
          title: '模板编码',
          align: 'center',
          dataIndex: 'code',
          width: 100,
        },
        {
          title: '模板名称',
          align: 'center',
          dataIndex: 'name',
          width: 150,
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'status',
          customRender:(text)=>{
              return text==='0'?'启用':'禁用'
            },
          width: 100,
        },
        {
          title: '操作',
          align: 'center',
          width: 100,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        }
      ],
      disableMixinCreated: true,
      url: {
        list: "/project/template/list",
        add: "/project/template/add",
      },
      formVisible: false,
      confirmLoading: false,
      formData: {},
      projectId: Vue.ls.get(CACHE_PROJECT_ID),
      centerList:[],
    
    }
  },
  mounted() {
    this.baseQueryParam = { projectId: this.projectId }
    this.loadData()
    getAction('/project/center/listAll',{projectId:this.projectId}).then(res=>{
        if(res.success){
          this.centerList = res.result
          if(this.centerList&&this.centerList.length>0){
            this.formData.centerId = this.centerList[0].centerId
          }
        }
      })
  },
  methods: {
    handleEditCode(record) {
      this.formData = Object.assign({}, record)
      this.formVisible = true
    },

    handleSubmit() {
      if (this.formData.id) {
        putAction('/project/template/edit', this.formData).then(res => {
          if (res.success) {
            this.searchQuery()
            this.handleCancel()
          }
        })
      }else{
        this.formData.projectId = this.projectId
        this.formData.type=0
        this.formData.name='知情同意书'
        this.formData.code='T1001'
        postAction('/project/template/add', this.formData).then(res => {
          if (res.success) {
            this.searchQuery()
            this.handleCancel()
          }
        })
      }
    },
    handleCancel() {
      this.formData = {}
      this.formVisible = false
    },
  }
}
</script>

<style scoped>
.editor-container {
  border: 1px solid #ccc;
  padding: 10px;
}
.custom-editor {
  /* 在这里定义j-editor的样式 */
  border: 2px solid red; /* 示例样式 */
  /* height: 600px; */
}
</style>